import { CSSProperties } from 'react';
import { Col } from 'react-bootstrap';

import PbmPromotionsLayout from '@/resources/components/product/pbmPromotions';
import { useModalReturn } from '@/resources/hooks/useModal';
import { ICartProduct } from '@/store/ducks/order/types';
import { IAlert, IOptionGroup, IProduct } from '@/store/ducks/products/types';

import BuyForm from '../BuyForm';

interface ProductWithPbmPromotionsProps {
  action: 'add' | 'receive';
  product: IProduct | ICartProduct;
  showType: 'Product' | 'OneLine' | 'Default' | 'Carousel';
  pbmPromotions: IAlert[];
  pbmBuyButton: boolean;
  styles?: CSSProperties;
  btnStyles?: CSSProperties;
  fullWidth: boolean;
  formClasses: string;
  optionModal: useModalReturn;
  optionsGroup: IOptionGroup | null;
  currentMeasure: 'kg' | 'unity';
  quantityInputDirection?: 'center' | 'end';
  isAvailable?: boolean;
  hideQuantityInput: boolean;
}

export const ProductWithPbmPromotions = ({
  action,
  product,
  showType,
  pbmPromotions,
  styles,
  btnStyles,
  fullWidth,
  formClasses,
  optionModal,
  optionsGroup,
  currentMeasure,
  quantityInputDirection,
  isAvailable,
  pbmBuyButton,
  hideQuantityInput,
}: ProductWithPbmPromotionsProps) => {
  return (
    <div className="col-12 pr-0 d-flex flex-lg-row-reverse flex-column align-items-end">
      <Col md={12} xl={7} sm={12} className="pl-lg-3 pl-0 pr-0">
        <BuyForm
          action={action}
          product={product}
          styles={styles}
          btnStyles={btnStyles}
          fullWidth={fullWidth}
          formClasses={formClasses}
          optionModal={optionModal}
          optionsGroup={optionsGroup}
          currentMeasure={currentMeasure}
          quantityInputDirection={quantityInputDirection}
          isAvailable={isAvailable}
          pbmBuyButton={pbmBuyButton}
          hideQuantityInput={hideQuantityInput}
        />
      </Col>
      <PbmPromotionsLayout pbmPromotions={pbmPromotions} type={showType} product={product} />
    </div>
  );
};
